enum EventBusConst {
  SELECTED_CUR_ORG_EVENT = 'SELECTED_CUR_ORG',
  LOGOUT_EVENT = 'LOGOUT_EVENT',
  LOGOUT_EVENT_HANDLED = 'LOGOUT_EVENT_HANDLED',
  MODAL_CLOSED = 'MODAL_CLOSED',
}
export default EventBusConst;
